/**
 * Healthcare Cluster Warning Dialog
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 */
goog.provide('yext.location.cluster.dialog.Base');
goog.provide('yext.location.cluster.dialog.incomplete');
goog.provide('yext.location.cluster.dialog.multiple');

/**
 * @typedef DialogOptions
 * @type Object
 * @property {function()} onCancel called when dialog is canceled
 * @property {function()} onUpdate called when dialog is updated
 * @property {function()} onUpdateAllSubmit called when submit is clicked with the update all profiles option selected
 * @property {function()} onUpdateCurrentSubmit action for when submit is clicked with the update current profile option selected
 */
/**
 * @constructor
 * Base container for cluster warning dialog
 * @param {DialogOptions} options Cluster Warning Dialog Options
 */
yext.location.cluster.dialog.Base = function(options) {
  this.$ctxt = options.container;
  this.options = options;

  if (this.$ctxt.length <= 0) {
    throw new Error('Dialog Context No Found');
  }

  this.createDialog();
  this.bindActions();
  this.show();
};

/**
 * Bind Dialog Actions
 */
yext.location.cluster.dialog.Base.prototype.bindActions = function() {
  var self = this;

  this.$ctxt.find('.js-cancel-btn').off('click').on('click', function() {
    self.$ctxt.dialog('close');
    self.reset();

    if (yext.isFunction(self.options.onCancel)) {
      self.options.onCancel();
    }
  });

  this.$ctxt.find('.js-submit-btn').off('click').on('click', function() {
    var selectedOptionVal = self.$ctxt.find('input[type="radio"]:checked').val();
    if (selectedOptionVal === 'update_all') {
      if (yext.isFunction(self.options.onUpdateAllSubmit)) {
        self.options.onUpdateAllSubmit();
      }
    } else if (selectedOptionVal === 'update_current') {
      if (yext.isFunction(self.options.onUpdateCurrentSubmit)) {
        self.options.onUpdateCurrentSubmit();
      }
    }

    // always run the onUpdate function
    if (yext.isFunction(self.options.onUpdate)) {
      self.options.onUpdate();
    }

    self.$ctxt.dialog('close');
  });
};

/**
 * Create the Dialog from the given context
 */
yext.location.cluster.dialog.Base.prototype.createDialog = function() {
  this.$ctxt.dialog({
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    minWidth: '330',
  });
};

/**
 * Show the dialog
 */
yext.location.cluster.dialog.Base.prototype.show = function() {
  this.$ctxt.dialog('open');
};

/**
 * reset dialog to default state
 */
yext.location.cluster.dialog.Base.prototype.reset = function() {
  var $updateAll = this.$ctxt.find('.js-update-all');
  if ($updateAll.length > 0) {
    $updateAll.attr('checked', true);
  }
};

/**
 * @constructor
 * Incomplete Cluster Warning Dialog
 * @param {DialogOptions} options Cluster Dialog Options
 */
yext.location.cluster.dialog.incomplete = function(options) {
  options.container = $('.js-incomplete-cluster-dialog');
  return new yext.location.cluster.dialog.Base(options);
};

/**
 * @constructor
 * Multiple Clusters Warning Dialog
 * @param {DialogOptions} options Cluster Dialog Options
 */
yext.location.cluster.dialog.multiple = function(options) {
  options.container = $('.js-multiple-cluster-dialog');
  return new yext.location.cluster.dialog.Base(options);
};
